import createReactClass from 'create-react-class';
import update from 'immutability-helper';
import React from 'react';
import DateTime from 'react-datetime';
import { FormBTrackRowView } from './trackRow';
import { MFTrackView } from './mfTrackRow';
import { BorderingFlagModal } from '../components/modalBorderingFlag';
import { CommentModalView } from '../components/modalComment';
import { ModalError } from '../components/modalError';
import Constants from '../constants/constants';

//stores
import { restrictionRequestStore } from '../stores/restrictionRequest';
import { userStore } from '../stores/user';
import { subdivisionStore } from '../stores/subdivision';
import { tabsStore } from '../stores/tabs';
import { schematicStore } from '../stores/schematic';

//action creators
import { FormRequestActions } from '../actions/formRequestActions';

import { formValidation as FormBValidator } from '../util/formValidation';
import moment from 'moment';

const TYPES = Constants.RestrictionTypes;

//function to get state from store, getting the currently loaded restriction
function getStateFromStores() {
  return {
    restriction: restrictionRequestStore.getForm(),
    activeRestriction: restrictionRequestStore.getActiveForm(),
    submitting: restrictionRequestStore.isSubmitting(),
    canSubmit: restrictionRequestStore.canSubmit(),
    isModifying: restrictionRequestStore.isModifying(),
    isDirty: restrictionRequestStore.isDirty(),
    reasonCodes: restrictionRequestStore.getReasonCodes(),
    readOnly: restrictionRequestStore.getReadOnly(),
    partialReadOnly: restrictionRequestStore.getPartialReadOnly(),
    errors: restrictionRequestStore.getErrors(),
    touchedFields: restrictionRequestStore.getTouchedFields(),
    formType: restrictionRequestStore.getFormType(),
    showDefaultTracks: restrictionRequestStore.getShowDefaultTracks(),
    tracksLoading: schematicStore.getTracksLoading(),
    trackHasError: schematicStore.isTrackHasError(),
    user: userStore.getSelectedRole(),
    isDispatcherRole: userStore.isDispatcherRole(),
    printLata: userStore.getLata(),
    subdivisionSelected: subdivisionStore.isSubSelected(),
    subData: subdivisionStore.getSubData(),
    schematicLoaded: restrictionRequestStore.isSchematicLoaded(),
    dispatcherCompaction: restrictionRequestStore.getDispatcherCompactionCode(),
    fieldUserCompaction: restrictionRequestStore.getFieldUserCompactionCode(),
    isWeatherRequest: restrictionRequestStore.getIsWeatherRequest(),
    batchMode: tabsStore.inBatchMode(),
    slodtTip: "Unable to edit issued restriction (except for SloDT). Please contact owning dispatcher"
  }
}

export const FormBFormView = createReactClass({
  intervalId: null,
  getInitialState: function () {
    return getStateFromStores();
  },

  componentDidMount: function () {
    restrictionRequestStore.subscribe(this._onChange);
    subdivisionStore.subscribe(this._onChange);
    userStore.subscribe(this._onChange);
    tabsStore.subscribe(this._onChange);
    schematicStore.subscribe(this._onChange);
    FormRequestActions.getDefaultTracksFromServer();
  },

  updateEffetiveTimeDate: function () {
    const {
      weatherWarningKey,
      futureEffectiveTimeExtension,
      minimumFutureEffectiveTimeLimit
    } = window.gritConfig;

    const { status, reasonDescription } = this.state.restriction;

    if (weatherWarningKey
      && String(reasonDescription).startsWith(weatherWarningKey)
      && status == 'request') {

      // clear existing interval
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      // for weather request, increase future effective time when it's near
      this.intervalId = setInterval(() => {
        const { restriction } = this.state;

        // clear interval if it's not request
        if (restriction?.status != "request") {
          clearInterval(this.intervalId);
          this.intervalId = null;
          return;
        }

        if (restriction.effectiveTime && restriction.effectiveDate) {

          const curTimezone = (restriction.timezone && restriction.timezone.trim() != "") ? restriction.timezone : "";
          const timeZone = Constants.Timezones[curTimezone]
          const currentTime = moment().tz(timeZone);
          const effectiveDate = moment.tz(restriction.effectiveDate + " " + restriction.effectiveTime, "MMDDYY HHmm",timeZone);

          const isUnderTimeLimit = (effectiveDate.diff(currentTime, "minutes") <= parseFloat(minimumFutureEffectiveTimeLimit));

          if (isUnderTimeLimit) {
            const afterAddingDateTime = currentTime.add(Number(futureEffectiveTimeExtension), "minutes");
            const updatedRestriction = {
              ...restriction,
              effectiveTime: afterAddingDateTime.format("HHmm"),
              effectiveDate: afterAddingDateTime.format("MMDDYY"),
            };
            this.setState({ restriction: updatedRestriction });
            FormRequestActions.formFieldChanged(updatedRestriction, "effectiveTime", true);
          } else {
            console.log("Effectivedate:" + effectiveDate.format("MMDDYY HHmm") + " is not less then " + minimumFutureEffectiveTimeLimit + " minutes.");
          }
        }
      }, 1000);
    }
  },

  componentDidUpdate: function (prevProps, prevState) {
    if (this.state.restriction && this.state.restriction != prevState.restriction) {
      this.updateEffetiveTimeDate();
    }
  },

  componentWillUnmount: function () {
    restrictionRequestStore.unsubscribe(this._onChange);
    subdivisionStore.unsubscribe(this._onChange);
    userStore.unsubscribe(this._onChange);
    tabsStore.unsubscribe(this._onChange);
    schematicStore.unsubscribe(this._onChange);
    clearInterval(this.intervalId);
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  getFormattedDate: function (date) {
    var dateVal = (('0' + (parseInt(date.getMonth()) + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + date.getFullYear().toString().substr(2, 2));
    return dateVal;
  },

  onFromDateChange: function (event) {
    this.updateDateState('workStartDate', event);
  },

  onFromDateBlur: function (event) {
    this.updateDateState('workStartDate', event);
  },

  onFromDateFocus: function () {
    setTimeout(function () {
      $('#startDate .dateInput').blur();
      $('#startDate .dateInput').focus();
    }, 10);
  },

  onToDateChange: function (event) {
    this.updateDateState('workEndDate', event);
  },

  onToDateBlur: function (event) {
    this.updateDateState('workEndDate', event);
  },

  onToDateFocus: function () {
    setTimeout(function () {
      $('#endDate .dateInput').blur();
      $('#endDate .dateInput').focus();
    }, 10);
  },

  onExpireDateChange: function (event) {
    this.updateDateState('expectedExpireDate', event);
  },

  onEstRemovalBlur: function (event) {
    this.updateDateState('expectedExpireDate', event);
  },

  onEstRemovalFocus: function () {
    setTimeout(function () {
      $('#expectDate .dateInput').blur();
      $('#expectDate .dateInput').focus();
    }, 10);
  },

  onEffDateChange: function (event) {
    this.updateDateState('effectiveDate', event);
  },

  onEffTimeBlur: function (event) {
    this.updateDateState('effectiveDate', event);
  },

  onEffDateFocus: function () {
    setTimeout(function () {
      $('#effDate .dateInput').blur();
      $('#effDate .dateInput').focus();
    }, 10);
  },

  updateDateState: function (fieldName, event) {
    var vals = {};

    var dateVal;
    if (event._d !== undefined) {
      dateVal = this.getFormattedDate(event._d);
    }
    else {
      dateVal = event;
    }
    vals[fieldName] = { $set: dateVal };
    var newState = update(this.state, {
      restriction: vals
    });
    this.setState(newState);
    FormRequestActions.dateFieldChanged(this.state.restriction, fieldName, dateVal);
    FormRequestActions.formFieldBlurred(this.state.restriction, fieldName);
  },

  //on change method to handle typing for regular inputs, stores values to component state, not the STORE!!
  onChangeUpper: function (event) {
    const regexUpper = /^[0-9a-zA-Z\b]+$/;
    if (event.target.value == '' || regexUpper.test(event.target.value)) {
      var target = event.target.id;
      var vals = {};
      vals[target] = { $set: event.target.value.toUpperCase() };
      var newState = update(this.state, {
        restriction: vals
      });
      this.setState(newState);
    }
  },

  onChangeAll: function (event) {
    if (event.target.value || event.target.value === '') {
      var target = event.target.id;
      var vals = {};
      vals[target] = { $set: event.target.value.toUpperCase() };
      var newState = update(this.state, {
        restriction: vals
      });
      this.setState(newState);
    }
  },

  onChange: function (event) {
    let regex = /^[0-9a-zA-Z\b]+$/;
    if ((event.target.id === "workStartTime")
      || (event.target.id === "workEndTime")
      || (event.target.id === "effectiveTime")) {
      regex = /^[0-9\b]+$/;
    }
    else if ((event.target.id === "workStartMpSuffix")
      || (event.target.id === "workEndMpSuffix")
      || (event.target.id === "shortFlagOneMpSuffix")
      || (event.target.id === "shortFlagTwoMpSuffix")) {
      regex = /^[a-zA-Z\b]+$/;
    }
    else if ((event.target.id === "workStartMp")
      || (event.target.id === "workEndMp")
      || (event.target.id === "shortFlagOneMp")
      || (event.target.id === "shortFlagTwoMp")
      || (event.target.id === "radioChannel")) {
      regex = /^[0-9.\b]+$/;
    }
    else if ((event.target.id === "phoneNumber")) {
      regex = /^[0-9-\b]+$/;
    }
    else if ((event.target.id === "freightSpeed")
      || (event.target.id === "passengerSpeed")) {
      regex = /^[0-9NAna\b]+$/;
    }
    if (event.target.value === '' || regex.test(event.target.value)) {
      var target = event.target.id;
      var vals = {};
      vals[target] = { $set: event.target.value.toUpperCase() };
      var newState = update(this.state, {
        restriction: vals
      });
      this.setState(newState);

      FormRequestActions.formFieldChanged(newState.restriction, target);
    }
  },

  onBlur: function (e) {
    FormRequestActions.formFieldBlurred(this.state.restriction, e.target.id);
  },

  onFocusUpdateSchematic: function () {
    FormRequestActions.calculateTracks(this.state.restriction);
  },

  onSelectChange: function (event) {
    FormRequestActions.selectChanged(event.target.id, event.target.value);
  },

  onReasonChange: function (event) {
    let index = event.target.selectedIndex;
    let reason = event.target.value;
    let reasonText = event.target[index].text;
    FormRequestActions.reasonChanged(reason, reasonText);
  },

  onNoFlagChange: function (event) {
    //modal confirm first...
    var restriction = this.state.restriction, id = event.target.id, checked = event.target.checked;
    if (restriction.shortFlagOneMp || restriction.shortFlagTwoMp || restriction.borderingFlags.length > 0) {
      window.confirm('Confirm No Flags',
        {
          description: 'Checking this option will remove all entered short flags and bordering flags.',
          confirmLabel: 'No Flags Displayed',
          abortLabel: 'Go Back'
        })
        .then(function () {
          FormRequestActions.noFlagsChanged(id, checked);

        });
    } else {
      FormRequestActions.noFlagsChanged(id, checked);
    }
  },

  onDefaultTracksChange: function (event) {
    var id = event.target.id, checked = event.target.checked;

    FormRequestActions.defaultTracksChanged(id, checked);
  },

  radioOnChange: function (e) {
    this.state.restriction.impedesTraffic = e.target.value;//update the react state
    this.onBlur(e);
  },

  //modify this to return the formBform view markup
  render: function () {
    //var submitButton = determineSubmitButtonType(this);
    //var deleteButton = determineDeleteButtonType(this);
    const { isDispatcherRole, isWeatherRequest, trackHasError } = this.state;
    var restriction = this.state.restriction;
    var content;
    var borderFlagCount = getBorderFlagCount(restriction);
    var commentCount = getCommentCount(restriction);
    var validRanges = determineValidRanges(this.state.subData);
    var isReadOnly = this.state.readOnly;
    var isPartialReadOnly = this.state.partialReadOnly;
    var isSchematicNotLoaded = !this.state.schematicLoaded;
    var areTracksLoading = this.state.tracksLoading;
    var restrTimeZone = this.state.restriction.timezone;
    var timezoneLabelStyle = {};
    var timezoneLabelTitle = "";
    var isSlwDt = this.state.partialReadOnly;
    var formType = this.props.type;
    var ttip = isPartialReadOnly ? this.state.slodtTip : "";
    let sloDtChangeComment = "";
    let isDispatcherCompactionCode = this.state.dispatcherCompaction;
    let isFieldUserCompactionCode = this.state.fieldUserCompaction;

    let activeRestriction = this.state.activeRestriction;

    const dispatcherWeatherRequest = isWeatherRequest && isDispatcherRole;
    isReadOnly = dispatcherWeatherRequest;

    if (restriction.timezone == null || restriction.timezone == "") {
      timezoneLabelStyle = { 'backgroundColor': 'red' };
      timezoneLabelTitle = "Unable to load timezone, please reload the subdivision";
      restrTimeZone = 'X';
    }

    var required = "*";
    if (this.state.user.indexOf(Constants.Roles.DISPATCHER) > -1) {
      required = "";
    }

    if (this.state.user.indexOf(Constants.Roles.READ_ONLY) === 0) {
      isReadOnly = true;
    }
    if (this.state.user.indexOf(Constants.Roles.FIELD_SLODT) > -1) {
      isSlwDt = false;
    }

    if (this.state.user.indexOf(Constants.Roles.FIELD_USER) === 0) {
      if (restriction.sloDtComment !== "" && restriction.sloDtComment !== undefined && restriction.sloDtComment !== null)
        sloDtChangeComment = "SloDT Change Comment: " + restriction.sloDtComment;
    }

    var commentRequired = false;
    if (restriction.excludedGuids && restriction.excludedGuids.length > 0) {
      if (!restriction.comments || restriction.comments.length === 0) {
        commentRequired = true;
      }
    }

    var availableTracks = schematicStore.getTrackData();
    var calculationGuidResult = schematicStore.getServerGuidCalculationResult();
    var trackNamesDisabledForFormB = []
    for (const trackDefinition of calculationGuidResult?.trackDefinitions ?? []) {
      for (const guid of [...trackDefinition.innerGuids, ...trackDefinition.innerGuidsList, ...trackDefinition.hostGuids, ...trackDefinition.hostGuidsList] ?? []) {
        if (guid.disableSidingForRestrictions) {
          trackNamesDisabledForFormB.push(trackDefinition.name.replace(/ /g, ''))
        }
      }
    }

    const tracksDisabledForFormB = availableTracks.filter(availableTrack => trackNamesDisabledForFormB.includes(availableTrack.name.replace(/ /g, '')));
    if (trackNamesDisabledForFormB.length > 0) {
      availableTracks = availableTracks.filter(availableTrack => !trackNamesDisabledForFormB.includes(availableTrack.name.replace(/ /g, '')))
    }

    //also show any tracks which might not be available in the MP range, but are on the restriction. Most likely caused by a geometry update or old name from MF
    var invalidTrackNames = restriction.tracks.filter(function (track) {
      var l = availableTracks.length;
      for (var i = 0; i < l; i++) {
        if (availableTracks[i].name.replace(/ /g, '') === track.name.replace(/ /g, '')) {
          return false;
        }
      }
      return true;

    });
    var tracksLoading = '';
    var tracks = '';
    var badTracks = '';
    var disabledForFormBTracks = '';

    if (areTracksLoading) {
      tracksLoading = "Calculating Tracks";
    }
    else {
      //read-only if this restriction has MF tracks on it
      if (invalidTrackNames.length > 0 && restriction.isPushedFromTss) {
        isReadOnly = true;
      }

      tracks = availableTracks.map(function (track, i) {
        return <FormBTrackRowView key={i} track={track} isReadOnly={isReadOnly || isPartialReadOnly}
          checkedTracks={restriction.tracks} />;
      });

      badTracks = invalidTrackNames.map(function (track, i) {
        return <MFTrackView key={i} track={track} />;
      });

      disabledForFormBTracks = tracksDisabledForFormB.map((track, i) =>
        <MFTrackView key={i} track={track} title="SIDING not allowed for Form B in TWC Territory"
          isChecked={false} isReadOnly={true} />);
    }

    let fromMpStyle = ({});
    let fromMpDesc = null;
    let toMpStyle = ({});
    let toMpDesc = null;
    let freightStyle = ({});
    let freightDesc = null;
    let passengerStyle = ({});
    let passengerDesc = null;
    let tracksStyle = ({});
    let tracksDesc = null;
    if (activeRestriction) {
      //This is a request to modify so we need to compare fields and find what changed
      // fromMpStyle = ({'backgroundColor': '#ffff00'});
      // fromMpDesc = "Current MP: " + activeRestriction.workStartMp;
      // toMpStyle = ({'backgroundColor': '#ffff00'});
      // toMpDesc = "Current MP: " + activeRestriction.workStartMp;
      if (restriction.freightSpeed !== activeRestriction.freightSpeed) {
        freightStyle = ({ 'backgroundColor': '#ffff00' });
        freightDesc = "Current Speed: " + activeRestriction.freightSpeed;
      }
      if (restriction.passengerSpeed !== activeRestriction.passengerSpeed) {
        passengerStyle = ({ 'backgroundColor': '#ffff00' });
        passengerDesc = "Current Speed: " + activeRestriction.passengerSpeed;
      }
      // tracksStyle = ({'backgroundColor': '#ffff00'});
      // tracksDesc = "Current Track(s): " + activeRestriction.tracks;
    }

    if (this.state.submitting) {
      content = (<p>Submitting Form...</p>)
    }
    else if (!this.state.subdivisionSelected) {
      var style = {
        'fontWeight': 'bold',
        'marginLeft': '10px',
        'marginTop': '10px',
        'fontSize': 'x-large'
      };


      content = (<div style={style}>Please select a subdivision</div>);
    }
    else {
      let reasonCodes = this.state.reasonCodes;
      const { weatherWarningKey } = window.gritConfig;
      if (!String(restriction.reasonDescription).startsWith(weatherWarningKey)) {
        reasonCodes = reasonCodes.filter(r => !(r.text && String(r.text).startsWith(weatherWarningKey)));
      }
      let reasons = reasonCodes.map((reason, i) =>
        (<option key={i + 1} value={reason.value}>{reason.text}</option>)
      );

      reasons.splice(
        0,
        0,
        <option disabled key={0} value="">
          Select...
        </option>
      );

      if (this.props.type === TYPES.B) {
        //form B markup

        if (this.state.isDirty) {
          window.onbeforeunload = function () {
            return "Some data has been entered, continuing will abandon all your work!"
          };
        }
        else {
          window.onbeforeunload = null;
        }

        //build the individual components of the form
        var fromMP = (<div>
          <label>
            *From MP:
          </label>
          <br />
          <input type="text"
            disabled={isReadOnly || isSchematicNotLoaded || areTracksLoading}
            onChange={this.onChange}
            onBlur={this.onBlur}
            value={restriction.workStartMp}
            id="workStartMp"
            className="mpInput"
            name="From Mp"
            placeholder="xxxx.x"
            pattern={FormBValidator.regex.mpRegex}
            maxLength="6"
            required />
          <input type="text"
            disabled={isReadOnly || isSchematicNotLoaded || areTracksLoading}
            onChange={this.onChange}
            onBlur={this.onBlur}
            value={restriction.workStartMpSuffix}
            id="workStartMpSuffix"
            name="From Mp Sfx"
            className="suffixInput"
            pattern={FormBValidator.regex.suffixRegex}
            maxLength="1" />
          <span className="glyphicon glyphicon-question-sign" title={validRanges} />
        </div>);
        var toMP = (<div>
          <label>
            *To MP:
          </label>
          <br />
          <input type="text"
            disabled={isReadOnly || isSchematicNotLoaded || areTracksLoading}
            onChange={this.onChange}
            onBlur={this.onBlur}
            value={restriction.workEndMp}
            id="workEndMp"
            className="mpInput"
            placeholder="xxxx.x"
            name="To Mp"
            pattern={FormBValidator.regex.mpRegex}
            maxLength="6"
            required />
          <input type="text"
            disabled={isReadOnly || isSchematicNotLoaded || areTracksLoading}
            onChange={this.onChange}
            onBlur={this.onBlur}
            value={restriction.workEndMpSuffix}
            id="workEndMpSuffix"
            name="To Mp Sfx"
            className="suffixInput"
            maxLength="1"
            pattern={FormBValidator.regex.suffixRegex} />
        </div>);
        var fromTime = (<div>
          <label>
            *From Time:
          </label>
          <br />
          <input type="text"
            disabled={isReadOnly || isSchematicNotLoaded}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            value={restriction.workStartTime}
            id="workStartTime"
            name="Start Time"
            placeholder="HHmm"
            pattern={FormBValidator.regex.timeRegex}
            maxLength="4"
            className="timeInput"
            required />
          <label id="timezone" style={timezoneLabelStyle} title={timezoneLabelTitle}>
            {restrTimeZone}
          </label>
        </div>);
        var fromDate = (<div>
          <label>
            *From Date:
          </label>
          <br />
          <div id="startDate">
            <DateTime type="text"
              value={restriction.workStartDate}
              id="workStartDate"
              dateFormat="MMDDYY"
              timeFormat={false}
              closeOnSelect={true}
              onFocus={this.onFromDateFocus}
              onChange={this.onFromDateChange}
              onBlur={this.onFromDateBlur}
              inputProps={{ placeholder: "MMDDYY", disabled: isReadOnly || isSchematicNotLoaded, className: "dateInput" }}
            />
          </div>
        </div>);
        var toTime = (<div>
          <label>
            *To Time:
          </label>
          <br />
          <input type="text"
            disabled={isReadOnly || isSchematicNotLoaded}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            value={restriction.workEndTime}
            id="workEndTime"
            name="End Time"
            pattern={FormBValidator.regex.timeRegex}
            placeholder="HHmm"
            maxLength="4"
            className="timeInput"
            required />
          <label id="timezone" style={timezoneLabelStyle} title={timezoneLabelTitle}>
            {restrTimeZone}
          </label>
        </div>);
        var toDate = (<div>
          <label>
            *To Date:
          </label>
          <br />
          <div id="endDate">
            <DateTime type="text"
              value={restriction.workEndDate}
              id="workEndDate"
              dateFormat="MMDDYY"
              timeFormat={false}
              closeOnSelect={true}
              onFocus={this.onToDateFocus}
              onChange={this.onToDateChange}
              onBlur={this.onToDateBlur}
              inputProps={{ placeholder: "MMDDYY", disabled: isReadOnly || isSchematicNotLoaded, className: "dateInput" }}
            />
          </div>
        </div>);
        var shortFlagOne = (<div>
          <label>
            Short Flag:
          </label>
          <br />
          <input type="text"
            disabled={isReadOnly || isSchematicNotLoaded || areTracksLoading}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            value={restriction.shortFlagOneMp}
            id="shortFlagOneMp"
            className="mpInput"
            name="From Short Flag Mp"
            placeholder="xxxx.x"
            maxLength="6"
            pattern={FormBValidator.regex.mpRegex} />
          <input type="text"
            disabled={isReadOnly || areTracksLoading}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            value={restriction.shortFlagOneMpSuffix}
            id="shortFlagOneMpSuffix"
            name="From Short Flag Mp Sfx"
            className="suffixInput"
            maxLength="1"
            pattern={FormBValidator.regex.suffixRegex} />
        </div>);
        var shortFlagTwo = (<div>
          <label>
            Short Flag:
          </label>
          <br />
          <input type="text"
            disabled={isReadOnly || isSchematicNotLoaded || areTracksLoading}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            value={restriction.shortFlagTwoMp}
            id="shortFlagTwoMp"
            className="mpInput"
            name="To Short Flag Mp"
            placeholder="xxxx.x"
            maxLength="6"
            pattern={FormBValidator.regex.mpRegex} />
          <input type="text"
            disabled={isReadOnly || isSchematicNotLoaded || areTracksLoading}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            value={restriction.shortFlagTwoMpSuffix}
            id="shortFlagTwoMpSuffix"
            name="To Short Flag Mp Sfx"
            className="suffixInput"
            maxLength="1"
            pattern={FormBValidator.regex.suffixRegex} />
        </div>);
        var foremanGang = (<div>
          <div style={{ display: 'inline-flex', border: 'black 1px solid' }}>
            *
            <div style={{ 'paddingRight': '4px', 'paddingLeft': '4px' }}>
              <label>
                Foreman Name:
              </label>
              <br />
              <input type="text"
                disabled={isReadOnly || isSchematicNotLoaded}
                onChange={this.onChangeAll}
                style={{ width: '150px' }}
                onBlur={this.onBlur}
                onFocus={this.onFocusUpdateSchematic}
                value={restriction.foremanName}
                id="foremanName"
                maxLength="22"
                name="Foreman Name" />
            </div>
            <div style={{ 'paddingRight': '4px', 'paddingLeft': '4px' }}>
              <label>
                Gang:
              </label>
              <br />
              <input type="text"
                disabled={isReadOnly || isSchematicNotLoaded}
                className="mpInput"
                onChange={this.onChangeAll}
                onBlur={this.onBlur}
                onFocus={this.onFocusUpdateSchematic}
                value={restriction.gang}
                maxLength="5"
                name="Gang"
                id="gang" />
            </div>
          </div>
        </div>);
        var phoneNumber = (<div>
          <label >
            {required}Phone:
          </label>
          <br />
          <input type="text"
            disabled={isReadOnly || isSchematicNotLoaded}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            style={{ width: '110px' }}
            value={restriction.phoneNumber}
            id="phoneNumber"
            name="Phone Number"
            maxLength="12"
            pattern={FormBValidator.regex.phoneRegex}
            placeholder="xxx-xxx-xxxx"
            required />
        </div>);
        var radioChannel = (<div>
          <label>
            {required}Radio Channel:
          </label>
          <br />
          <input type="text"
            disabled={isReadOnly || isSchematicNotLoaded}
            style={{ width: '75px' }}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            value={restriction.radioChannel}
            id="radioChannel"
            name="Radio Channel"
            maxLength="10"
            required />
        </div>);
        var reason = (<div>
          <label>
            *Reason:
          </label>
          <br />
          <select id="reason"
            disabled={isReadOnly || isSchematicNotLoaded}
            onChange={this.onReasonChange}
            onFocus={this.onFocusUpdateSchematic}
            value={restriction.reason}
            name="Reason"
            style={{ width: '250px' }}
            required>
            {reasons}
          </select>
        </div>);
        var impedesTraffic = (<div>
          <label>
            {required}Will this restriction
          </label>
          <br />

          <div><label>impede traffic:</label>
            <input type="radio"
              disabled={isReadOnly || isSchematicNotLoaded}
              name="Impedes Traffic"
              onChange={this.radioOnChange}
              checked={restriction.impedesTraffic === 'Y'}
              id="impedesTraffic"
              value="Y" />Yes
            <input type="radio"
              disabled={isReadOnly}
              name="Impedes Traffic"
              onChange={this.radioOnChange}
              checked={restriction.impedesTraffic === 'N'}
              id="impedesTraffic"
              value="N" />No
          </div>
        </div>);
        var commentModal = (<div>
          <CommentModalView
            restriction={restriction}
            commentCount={commentCount}
            isReadOnly={isReadOnly}
            isWeatherRequest={isWeatherRequest}
            required={commentRequired}
            disabled={isPartialReadOnly}
            actionCreator={FormRequestActions}
            formType={formType}
            tip={""}
          />
        </div>);
        var borderModal = (<div>
          <BorderingFlagModal
            restriction={restriction}
            isReadOnly={isReadOnly}
            borderFlagCount={borderFlagCount}
            actionCreator={FormRequestActions}
            formType={formType}
            tip={""}
          />
        </div>);
        var track = (<div>
          <label>
            *Tracks:
          </label>
          <br />

          <div id="trackContainer">
            {disabledForFormBTracks}
            {badTracks}
            {tracksLoading}
            {tracks}
          </div>
        </div>);

        content = (
          <div id="create-formBRestriction" className="content scaffold-create" role="main">
            <form name="formBform" autoComplete="off">
              <fieldset className="form">
                <div id="controlLayoutGrid" className="container">
                  <div className="row">{/*entire form row*/}
                    <div className="col-xs-8 col-sm-9 col-md-9 col-lg-9">
                      <div className="gridRowPadding row">
                        <div className="col-xs-6 col-sm-4 col-md-6 col-lg-2">
                          {fromMP}
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-6 col-lg-2">
                          {toMP}
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                          {fromTime}
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                          {fromDate}
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                          {toTime}
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                          {toDate}
                        </div>
                      </div>
                      <div className="gridRowPadding row">
                        <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                          {shortFlagOne}
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                          {shortFlagTwo}
                        </div>
                        <div className="col-xs-12 col-sm-10 col-md-4 col-lg-4">
                          {foremanGang}
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-4 col-lg-2">
                          {phoneNumber}
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-4 col-lg-2">
                          {radioChannel}
                        </div>
                      </div>
                      <div className="gridRowPadding row">
                        <div className="col-xs-12 col-sm-10 col-md-6 col-lg-4">
                          {reason}
                        </div>
                        <div className="col-xs-12 col-sm-10 col-md-4 col-lg-3">
                          {impedesTraffic}
                        </div>
                        <div className="col-xs-6 col-sm-10 col-md-4 col-lg-2">
                          <br />
                          {commentModal}
                        </div>
                        <div className="col-xs-6 col-sm-10 col-md-4 col-lg-2">
                          <br />
                          {borderModal}
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-4 col-sm-3 col-md-3 col-lg-3">
                      <div className="row">
                        <div className="col-lg-12">
                          {track}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*end entire form row*/}
                </div>
              </fieldset>
            </form>
          </div>
        );

      }
      else if (this.props.type === TYPES.A) {
        var isDarkCss = (this.state.restriction.status === Constants.RestrictionStatuses.ISSUED && this.state.user.indexOf(Constants.Roles.FIELD_USER) === 0 && this.state.partialReadOnly)

        var highlightFutureEffDate = (this.state.restriction.effectiveDate != null && this.state.restriction.effectiveDate != '');
        var highlightFutureEffTime = (this.state.restriction.effectiveTime != null && this.state.restriction.effectiveTime != '');

        var fromMpA = (<div>
          <label style={fromMpStyle} title={fromMpDesc}>
            *From MP:
          </label>
          <br />
          <input type="text"
            disabled={(isReadOnly && !trackHasError) || isPartialReadOnly || isSchematicNotLoaded || areTracksLoading}
            value={restriction.workStartMp}
            id="workStartMp"
            onChange={this.onChange}
            onBlur={this.onBlur}
            className={isDarkCss ? "mpInput darkCss" : "mpInput"}
            name="From Mp"
            placeholder="xxxx.x"
            maxLength="6"
            title={isDarkCss ? this.state.slodtTip : ""}
            required />
          <input type="text"
            disabled={(isReadOnly && !trackHasError) || isPartialReadOnly || isSchematicNotLoaded || areTracksLoading}
            value={restriction.workStartMpSuffix}
            id="workStartMpSuffix"
            onChange={this.onChange}
            onBlur={this.onBlur}
            name="From Mp Sfx"
            className={isDarkCss ? "suffixInput darkCss" : "suffixInput"}
            maxLength="1"
            title={isDarkCss ? this.state.slodtTip : ""} />
          <span className="glyphicon glyphicon-question-sign" title={validRanges} />
        </div>);
        var toMpA = (<div>
          <label style={toMpStyle} title={toMpDesc}>
            *To MP:
          </label>
          <br />
          <input type="text"
            disabled={(isReadOnly && !trackHasError) || isPartialReadOnly || isSchematicNotLoaded || areTracksLoading}
            value={restriction.workEndMp}
            id="workEndMp"
            onChange={this.onChange}
            onBlur={this.onBlur}
            className={isDarkCss ? "mpInput darkCss" : "mpInput"}
            placeholder="xxxx.x"
            name="To Mp"
            maxLength="6"
            title={isDarkCss ? this.state.slodtTip : ""}
            required />
          <input type="text"
            disabled={(isReadOnly && !trackHasError) || isPartialReadOnly || isSchematicNotLoaded || areTracksLoading}
            value={restriction.workEndMpSuffix}
            id="workEndMpSuffix"
            onChange={this.onChange}
            onBlur={this.onBlur}
            name="To Mp Sfx"
            className={isDarkCss ? "suffixInput darkCss" : "suffixInput"}
            title={isDarkCss ? this.state.slodtTip : ""}
            maxLength="1" />
        </div>);
        var passSpeed = (<div>
          <label className="noWrap" style={passengerStyle} title={passengerDesc}>
            *Passenger
          </label>
          <br />

          <div>
            <label style={passengerStyle} title={passengerDesc}>Speed:</label>
            <input type="text"
              disabled={isReadOnly || isPartialReadOnly || isSchematicNotLoaded}
              value={restriction.passengerSpeed}
              id="passengerSpeed"
              className={isDarkCss ? "passengerSpeedInput darkCss" : "passengerSpeedInput"}
              onChange={this.onChange}
              onBlur={this.onBlur}
              onFocus={this.onFocusUpdateSchematic}
              name="Passenger Speed"
              title={isDarkCss ? this.state.slodtTip : passengerDesc}
              maxLength="2" />
          </div>
        </div>);
        var freightSpeed = (<div>
          <label className="noWrap" style={freightStyle} title={freightDesc}>
            *Freight
          </label>
          <br />

          <div>
            <label style={freightStyle} title={freightDesc}>Speed:</label>
            <input type="text"
              disabled={isReadOnly || isPartialReadOnly || isSchematicNotLoaded}
              value={restriction.freightSpeed}
              id="freightSpeed"
              className={isDarkCss ? "freightSpeedInput darkCss" : "freightSpeedInput"}
              onChange={this.onChange}
              onBlur={this.onBlur}
              onFocus={this.onFocusUpdateSchematic}
              name="Freight Speed"
              title={isDarkCss ? this.state.slodtTip : freightDesc}
              maxLength="2" />
          </div>
        </div>);
        var estimatedRemoval = (<div title={sloDtChangeComment}>
          <label>
            *Estimated Removal
          </label>
          <br />

          <div id="expectDate">
            <DateTime type="text"
              value={restriction.expectedExpireDate}
              id="expectedExpireDate"
              ref="expectedExpireDate"
              dateFormat="MMDDYY"
              timeFormat={false}
              closeOnSelect={true}
              onFocus={this.onEstRemovalFocus}
              onChange={this.onExpireDateChange}
              onBlur={this.onEstRemovalBlur}
              inputProps={{ placeholder: "MMDDYY", disabled: isReadOnly || isSchematicNotLoaded || isSlwDt, className: "dateInput" }}
            />
          </div>
        </div>);
        var noFlagsA = (<div>
          <label>
            No Flags:
          </label>
          <br />
          <input type="checkbox"
            disabled={isReadOnly || isPartialReadOnly || isSchematicNotLoaded}
            checked={restriction.shortFlagsNotDisplayed}
            id="noFlagCheckBox"
            name="No Flag Option"
            title={isDarkCss ? this.state.slodtTip : ""}
            className={isDarkCss ? "checkbox darkCss" : "checkbox"}
            onChange={this.onNoFlagChange} />
        </div>);
        var shortFlagOneA = (<div>
          <label>
            Short Flag:
          </label>
          <br />
          <input type="text"
            disabled={isReadOnly || isPartialReadOnly || restriction.shortFlagsNotDisplayed || isSchematicNotLoaded || areTracksLoading}
            value={restriction.shortFlagOneMp}
            id="shortFlagOneMp"
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            className={isDarkCss ? "mpInput darkCss" : "mpInput"}
            name="From Short Flag Mp"
            placeholder="xxxx.x"
            title={isDarkCss ? this.state.slodtTip : ""}
            maxLength="6" />
          <input type="text"
            disabled={isReadOnly || isPartialReadOnly || restriction.shortFlagsNotDisplayed || isSchematicNotLoaded || areTracksLoading}
            value={restriction.shortFlagOneMpSuffix}
            id="shortFlagOneMpSuffix"
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            name="From Short Flag Mp Sfx"
            className={isDarkCss ? "suffixInput darkCss" : "suffixInput"}
            title={isDarkCss ? this.state.slodtTip : ""}
            maxLength="1" />
        </div>);
        var shortFlagTwoA = (<div>
          <label>
            Short Flag:
          </label>
          <br />
          <input type="text"
            disabled={isReadOnly || isPartialReadOnly || restriction.shortFlagsNotDisplayed || isSchematicNotLoaded || areTracksLoading}
            value={restriction.shortFlagTwoMp}
            id="shortFlagTwoMp"
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            className={isDarkCss ? "mpInput darkCss" : "mpInput"}
            name="To Short Flag Mp"
            placeholder="xxxx.x"
            title={isDarkCss ? this.state.slodtTip : ""}
            maxLength="6" />
          <input type="text"
            disabled={isReadOnly || isPartialReadOnly || restriction.shortFlagsNotDisplayed || isSchematicNotLoaded || areTracksLoading}
            value={restriction.shortFlagTwoMpSuffix}
            id="shortFlagTwoMpSuffix"
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            name="To Short Flag Mp Sfx"
            className={isDarkCss ? "suffixInput darkCss" : "suffixInput"}
            title={isDarkCss ? this.state.slodtTip : ""}
            maxLength="1" />
        </div>);
        var effDate = (<div>
          <label className={highlightFutureEffDate ? "highlightField" : ""}>
            Future Eff Date:
          </label>
          <br />
          <div id="effDate">
            <DateTime
              id="effectiveDate"
              ref="effectiveDate"
              dateFormat="MMDDYY"
              timeFormat={false}
              closeOnSelect={true}
              onFocus={this.onEffDateFocus}
              onChange={this.onEffDateChange}
              onBlur={this.onEffTimeBlur}
              name="Effective Date"
              value={restriction.effectiveDate}
              inputProps={{ placeholder: "MMDDYY", disabled: isReadOnly || isSchematicNotLoaded || isPartialReadOnly, title: isDarkCss ? this.state.slodtTip : "", className: isDarkCss ? "dateInput darkCss" : "dateInput" }}
            />
          </div>
        </div>);
        var effTime = (<div>
          <label className={highlightFutureEffTime ? "highlightField" : ""}>
            Future Eff Time:
          </label>
          <br />
          <input type="text"
            disabled={isReadOnly || isPartialReadOnly || isSchematicNotLoaded}
            value={restriction.effectiveTime}
            id="effectiveTime"
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            name="Effective Time"
            className={isDarkCss ? "timeInput darkCss" : "timeInput"}
            maxLength="4"
            title={isDarkCss ? this.state.slodtTip : ""}
            placeholder="HHmm" />
          <input type="hidden"
            value={restriction.effectiveTimePrevious}
            id="effectiveTimePrevious"
            name="Effective Time Previous"
            placeholder="HHmm" />
          <label id="timezone" style={timezoneLabelStyle} title={timezoneLabelTitle}>
            {restrTimeZone}
          </label>
        </div>);
        var reasonA = (<div>
          <label>
            *Reason:
          </label>
          <br />
          <select id="reason"
            onChange={this.onReasonChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            disabled={isReadOnly || isSchematicNotLoaded || isSlwDt || isDispatcherCompactionCode || isFieldUserCompactionCode}
            value={restriction.reason}
            name="Reason"
            style={{ width: '200px' }}
            required>
            {reasons}
          </select>
        </div>);
        var authBy = (<div>
          <label>
            *Requested By:
          </label>
          <br />
          <input type="text"
            disabled={isReadOnly || isPartialReadOnly || isSchematicNotLoaded}
            value={restriction.authorizedBy}
            id="authorizedBy"
            onChange={this.onChangeAll}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            className={isDarkCss ? "requestedInput darkCss" : "requestedInput"}
            maxLength="20"
            title={isDarkCss ? this.state.slodtTip : ""}
            name="Authorized By" />
        </div>);
        var phoneNumberA = (<div>
          <label>
            {required}Phone:
          </label>
          <br />
          <input type="text"
            disabled={isReadOnly || isPartialReadOnly || isSchematicNotLoaded}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocusUpdateSchematic}
            value={restriction.phoneNumber}
            id="phoneNumber"
            className={isDarkCss ? "phoneNumberInput darkCss" : "phoneNumberInput"}
            name="Phone Number"
            maxLength="12"
            title={isDarkCss ? this.state.slodtTip : ""}
            pattern={FormBValidator.regex.phoneRegex}
            placeholder="xxx-xxx-xxxx"
            required />
        </div>);
        var commentModalA = (<div>
          <CommentModalView
            restriction={restriction}
            commentCount={commentCount}
            required={commentRequired}
            isReadOnly={isReadOnly || isPartialReadOnly || isSchematicNotLoaded}
            disabled={isPartialReadOnly}
            actionCreator={FormRequestActions}
            isWeatherRequest={isWeatherRequest}
            tip={ttip} />
        </div>);
        var borderModalA = (<div>
          <BorderingFlagModal
            restriction={restriction}
            isReadOnly={isReadOnly || isPartialReadOnly || restriction.shortFlagsNotDisplayed || isSchematicNotLoaded}
            isDisabled={restriction.shortFlagsNotDisplayed}
            borderFlagCount={borderFlagCount}
            actionCreator={FormRequestActions}
            tip={ttip} />
        </div>);
        var trackA = (<div>
          <label style={tracksStyle} title={tracksDesc}>
            *Tracks:
          </label>
          <br />

          <div id="trackContainer">
            {badTracks}
            {tracksLoading}
            {tracks}
          </div>
        </div>);

        content = (
          <div id="create-formBRestriction" className="content scaffold-create" role="main">
            <form name="formAform" autoComplete="off">
              <fieldset className="form">
                <div id="controlLayoutGrid" className="container">
                  <div className="row">

                    <div className=" col-xs-8 col-sm-9 col-md-9 col-lg-9">
                      <div className="gridRowPadding row">
                        <div className="col-xs-6 col-sm-3 col-md-3 col-lg-2">
                          {fromMpA}
                        </div>
                        <div className="col-xs-6 col-sm-3 col-md-3 col-lg-2">
                          {toMpA}
                        </div>
                        <div className="col-xs-6 col-sm-3 col-md-3 col-lg-2">
                          {passSpeed}
                        </div>
                        <div className="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                          {freightSpeed}
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-3">
                          {estimatedRemoval}
                        </div>

                      </div>
                      <div className="gridRowPadding row">
                        <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2">
                          {shortFlagOneA}
                        </div>
                        <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2">
                          {shortFlagTwoA}
                        </div>
                        <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2">
                          {noFlagsA}
                        </div>
                        <div className="col-xs-6 col-sm-3 col-md-3 col-lg-20">
                          {effDate}
                        </div>
                        <div className="col-xs-6 col-sm-3 col-md-3 col-lg-3">
                          {effTime}
                        </div>
                      </div>

                      <div className="gridRowPadding row">
                        <div className="col-xs-8 col-sm-6 col-md-4 col-lg-3">
                          {reasonA}
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-4 col-lg-3">
                          {authBy}
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-4 col-lg-2">
                          {phoneNumberA}
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-4 col-lg-2">
                          <br />
                          {commentModalA}
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-4 col-lg-2">
                          <br />
                          {borderModalA}
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-4 col-sm-3 col-md-3 col-lg-3">
                      <div className="row">
                        <div className="col-lg-12">
                          {trackA}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        );
      }
    }

    var formID = "form" + this.props.type + "form";
    //build up the form and bind the values
    return (
      <div id={formID} className="formScrollWrapper">
        {content}
        {<ModalError />}
      </div>
    );
  },
});



function determineValidRanges(subData) {

  if (subData && subData.milePostRangeList && subData.milePostRangeList.length > 0) {
    var strings = subData.milePostRangeList.map(function (range) {
      return range.from + (range.sfx ? range.sfx : "") + ' to ' + range.to + (range.sfx ? range.sfx : "")
    });
    strings.splice(0, 0, "Valid Ranges:");
    return strings.join('\n');
  }
  return "No Ranges Found";

}

function getCommentCount(restr) {
  if (restr.comments) {
    return restr.comments.length
  }
  return 0;
}

function getBorderFlagCount(restr) {
  if (restr.borderingFlags) {
    return restr.borderingFlags.length
  }
  return 0;
}
